/**
 * @file    AccountSelect.css
 *
 *          Stylesheet for the AccountSelect component.
 *
 * @author  Severn Lortie <severn@distributive.network>
 * @date    Feb 2024
 */
select.accountSelect {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: black;
}

select.accountSelect:invalid {
  font-weight: bold;
}